<template>
  <div class="hold-transition">
    <Loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Programaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">Operación</li>
                  <li class="breadcrumb-item">Procesos</li>
                  <li class="breadcrumb-item">Programaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync-alt fa-spin"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="create()"
                        v-if="
                          $store.getters.can('argentina.programaciones.create')
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead class="text-center align-middle bg-dark">
                    <tr>
                      <th>
                        N°
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.id"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Fecha inicial
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_inicial"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Fecha final
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha_final"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Estado
                        <select
                          v-model="filtros.estado"
                          @change="getIndex()"
                          class="form-control form-control-sm"
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            v-bind:key="estado.numeracion"
                            v-bind:value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th class="align-middle">Fecha creación</th>
                      <th class="align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr
                      v-for="programacion in programaciones.data"
                      :key="programacion.id"
                    >
                      <td>{{ programacion.id }}</td>
                      <td>{{ programacion.fecha_inicial }}</td>
                      <td>{{ programacion.fecha_final }}</td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            programacion.estado == 1
                              ? 'badge-warning'
                              : 'badge-success'
                          "
                          :title="programacion.nEstado"
                        >
                          {{ programacion.nEstado }}
                        </span>
                      </td>
                      <td>{{ programacion.created_at.substring(0, 10) }}</td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-sm bg-navy"
                          @click="edit(programacion.id)"
                          v-if="
                            $store.getters.can('argentina.programaciones.edit')
                          "
                        >
                          <i class="fas fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="programaciones.total">
                  <p>
                    Mostrando del <b>{{ programaciones.from }}</b> al
                    <b>{{ programaciones.to }}</b> de un total:
                    <b>{{ programaciones.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="programaciones"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right m-0"
                >
                </pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";

export default {
  name: "ProgramacionIndex",
  components: {
    pagination,
    Loading,
  },
  data() {
    return {
      filtros: {
        id: null,
        fecha_inicial: null,
        fecha_final: null,
        estado: null,
      },
      listasForms: {
        estados: [],
      },
      programaciones: {},
      cargando: false,
    };
  },

  beforeMount() {
    this.getIndex();
    this.getEstados();
  },

  mounted() {
    this.getIndex();
  },

  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/argentina/programaciones?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.programaciones = response.data;
          this.cargando = false;
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    create() {
      return this.$router.push({
        name: "/Argentina/Operacion/ProgramacionForm",
        params: {
          accion: "Crear",
          id: 0,
        },
      });
    },

    edit(id) {
      return this.$router.push({
        name: "/Argentina/Operacion/ProgramacionForm",
        params: {
          accion: "Editar",
          id: id,
        },
      });
    },
  },
};
</script>